import React, { useEffect, useState } from "react";
import {
  getAuthOrgs,
  getAuthOrgsClonedUsers,
  getAuthOrgsUsers,
  getAuthOrgsTrusteeUserRoles,
  getAuthOrgsGroups,
  getAuthOrgsTrusteeGroupRoles,
} from "../utilities/genesysCloudUtils";
import "../App.css";
import { DxButton } from "genesys-react-components";

export function AuthOrgs({ setPageCount, pageNumber, setPageNumber, org, setTabName, setOpts, setIsVisible }) {
  console.log("AuthOrgs props", org);
  const [authOrgs, setAuthOrgs] = useState([]);

  useEffect(() => {
    generateAuthOrgs();
  }, [pageNumber]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setPageNumber(1);
    setTabName("auth-orgs-tab");
    setOpts({})
    setIsVisible({ divisions: false, object: false, applyButton: false })
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const generateAuthOrgs = () => {
    getAuthOrgs().then((data) => {
      setAuthOrgs(data.entities);
      setPageCount(data.pageCount);
    });
  };

  const generateAuthOrgsDetails = (orgId) => {
    // Check if data already exists for this organization
    const existingOrg = authOrgs.find((org) => org.id === orgId);
    if (
      existingOrg &&
      existingOrg.clonedUsers &&
      existingOrg.authUsers &&
      existingOrg.authGroups
    ) {
      console.log("Data already loaded for organization:", orgId);
      return;
    }

    // Only fetch cloned users if not already loaded
    if (!existingOrg?.clonedUsers) {
      getAuthOrgsClonedUsers(orgId).then((data) => {
        setAuthOrgs((prevAuthOrgs) => {
          return prevAuthOrgs.map((authOrg) => {
            if (authOrg.id === orgId) {
              return { ...authOrg, clonedUsers: data.entities };
            }
            return authOrg;
          });
        });
      });
    }

    // Only fetch trustee users if not already loaded
    if (!existingOrg?.authUsers) {
      getAuthOrgsUsers(orgId).then(async (data) => {
        // Get roles for each user
        const usersWithRoles = await Promise.all(
          data.entities.map(async (user) => {
            try {
              const rolesData = await getAuthOrgsTrusteeUserRoles(
                orgId,
                user.id
              );
              return { ...user, roles: rolesData };
            } catch (error) {
              console.error(`Error fetching roles for user ${user.id}:`, error);
              return { ...user, roles: [] };
            }
          })
        );

        setAuthOrgs((prevAuthOrgs) => {
          return prevAuthOrgs.map((authOrg) => {
            if (authOrg.id === orgId) {
              return { ...authOrg, authUsers: usersWithRoles };
            }
            return authOrg;
          });
        });
      });
    }

    // Only fetch trustee groups if not already loaded
    if (!existingOrg?.authGroups) {
      getAuthOrgsGroups(orgId).then(async (data) => {
        const groupsWithRoles = await Promise.all(
          data.entities.map(async (group) => {
            try {
              const rolesData = await getAuthOrgsTrusteeGroupRoles(
                orgId,
                group.id
              );
              return { ...group, roles: rolesData };
            } catch (error) {
              console.error(
                `Error fetching roles for group ${group.id}:`,
                error
              );
              return { ...group, roles: [] };
            }
          })
        );

        setAuthOrgs((prevAuthOrgs) => {
          return prevAuthOrgs.map((authOrg) => {
            if (authOrg.id === orgId) {
              return { ...authOrg, authGroups: groupsWithRoles };
            }
            return authOrg;
          });
        });
      });
    }

    console.log("authOrgs", authOrgs);
  };

  const handleAuthOrgsExpand = (event, orgId, index) => {
    console.log("checked", event.target.checked);
    if (event.target.checked) {
      generateAuthOrgsDetails(orgId);
    }
  };

  return (
    <>
      {authOrgs ? (
        <>
          <table className="table auth-orgs-table">
            <thead>
              <tr>
                <th>Count</th>
                <th>Authorized Org Name</th>
                <th>trusteeOrgId</th>
              </tr>
            </thead>
            <tbody>
              {authOrgs.map((authOrg, index) => {
                return (
                  <tr key={authOrg.id}>
                    <th className="index">
                      {pageNumber === 1
                        ? index + 1
                        : (pageNumber - 1) * 100 + index + 1}
                    </th>
                    <td>
                      <div className="collapse collapse-arrow">
                        <input
                          type="checkbox"
                          onChange={(event) =>
                            handleAuthOrgsExpand(event, authOrg.id, index)
                          }
                        />
                        <div className="collapse-title">
                          {authOrg.organization.name}
                        </div>
                        <div className="collapse-content">
                          <div className="overflow-x-auto">
                            <table className="table table-sm auth-org-entities-table">
                              <thead>
                                <tr>
                                  <th></th>
                                  <th>Cloned Users</th>
                                  <th></th>
                                  <th>Id</th>
                                </tr>
                              </thead>
                              <tbody>
                                {authOrg.clonedUsers &&
                                  authOrg.clonedUsers.map((user, index) => (
                                    <tr key={index + 1}>
                                      <td>{index + 1}</td>
                                      <td>{user.name}</td>
                                      <td></td>
                                      <td>
                                        <kbd className="kbd">{user.id}</kbd>
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                            <table className="table table-sm auth-org-entities-table">
                              <thead>
                                <tr>
                                  <th></th>
                                  <th>Authorized Users</th>
                                  {org && org !== "DEV" ? (
                                    <th>Roles</th>
                                  ) : (
                                    <th></th>
                                  )}
                                  <th>User Id</th>
                                </tr>
                              </thead>
                              <tbody>
                                {authOrg.authUsers &&
                                  authOrg.authUsers.map((user, index) => (
                                    <tr key={index + 1}>
                                      <td>{index + 1}</td>
                                      <td>{user.name}</td>
                                      {org !== "DEV" && user.roles ? (
                                        <td>
                                          {user.roles.map((role, roleIndex) => (
                                            <DxButton
                                              key={roleIndex}
                                              type="primary"
                                              className="auth-org"
                                            >
                                              {role}
                                            </DxButton>
                                          ))}
                                        </td>
                                      ) : (
                                        <td></td>
                                      )}
                                      <td>
                                        <kbd className="kbd">{user.id}</kbd>
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                            <table className="table table-sm auth-org-entities-table">
                              <thead>
                                <tr>
                                  <th></th>
                                  <th>Authorized Groups</th>
                                  {org && org !== "DEV" ? (
                                    <th>Roles</th>
                                  ) : (
                                    <th>Member Count</th>
                                  )}
                                  <th>Group Id</th>
                                </tr>
                              </thead>
                              <tbody>
                                {authOrg.authGroups &&
                                  authOrg.authGroups.map((group, index) => (
                                    <tr key={index + 1}>
                                      <td>{index + 1}</td>
                                      <td>{group.name}</td>
                                      {org !== "DEV" && group.roles ? (
                                        <td>
                                          {group.roles.map(
                                            (role, roleIndex) => (
                                              <DxButton
                                                key={roleIndex}
                                                type="primary"
                                                className="auth-org"
                                              >
                                                {role}
                                              </DxButton>
                                            )
                                          )}
                                        </td>
                                      ) : (
                                        <td>{group.memberCount}</td>
                                      )}
                                      <td>
                                        <kbd className="kbd">{group.id}</kbd>
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <kbd className="kbd">{authOrg.id}</kbd>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </>
      ) : (
        <h1>Loading...</h1>
      )}
    </>
  );
}
